/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VirtualMachineAgentsSummarySortCriteria {
    getFixupPrototypeFunction() { return VirtualMachineAgentsSummarySortCriteria.fixupPrototype; }

    static newInstance(model: Partial<VirtualMachineAgentsSummarySortCriteria>): VirtualMachineAgentsSummarySortCriteria {
        let obj = Object.assign(new VirtualMachineAgentsSummarySortCriteria(), model);
        VirtualMachineAgentsSummarySortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VirtualMachineAgentsSummarySortCriteria>): VirtualMachineAgentsSummarySortCriteria {
        if (!model) return null;
        return VirtualMachineAgentsSummarySortCriteria.newInstance(<VirtualMachineAgentsSummarySortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VirtualMachineAgentsSummarySortCriteria) {
        if (!obj) return;

        models.VirtualMachineAgentsSummarySortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VirtualMachineAgentsSummarySortCriteria): boolean {
        Object.setPrototypeOf(obj, VirtualMachineAgentsSummarySortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.VirtualMachineAgentsSummarySortColumn;

    ascending: boolean;

}
